import React, { useState, Fragment } from 'react';

import LogComponent from './logs';
import FiltersComponent from './filters';

const LogContainer = () => {

  const [logs, setLogsView] = useState(false);
  const [filters, setFilters] = useState([]);

  const loadLogs = () => {
    setLogsView(true);
  }

  const loadFilters = () => {
    setLogsView(false);
    setFilters([]);
  }

  return <Fragment>
    {!logs ? <FiltersComponent loadLogs={loadLogs} setFilters={setFilters} /> : <LogComponent loadFilters={loadFilters} filters={filters} />}
  </Fragment>;
}

export default LogContainer;